export default "__VITE_ASSET__Crdr4Q_7__"